<template>
    <el-divider v-if="element.tpl() == 'divider'"></el-divider>
    <component v-else :is="element.tpl()"
    v-bind="element.props()"></component>
</template>

<script>
import InputSelect from './InputSelect'
import InputText from './InputText'
import InputSelectRemote from './InputSelectRemote'
import InputSelectRemoteSuggestion from './InputSelectRemoteSuggestion'
import InputTextWithSuggestions from './InputTextWithSuggestions'
import InputTextWithLocalSuggestions from './InputTextWithLocalSuggestions'
import InputCSRWithBalance from './InputCSRWithBalance'
import InputTagWithOrderType from './InputTagWithOrderType'
import InputDatePicker from './InputDatePicker'
import InputDateRangePicker from './InputDateRangePicker'
import InputShow from './InputShow'

import { make } from '../providers/element'

export default {
  name: 'ElementCreator',
  components: {
    InputSelect,
    InputText,
    InputSelectRemote,
    InputSelectRemoteSuggestion,
    InputTextWithSuggestions,
    InputTextWithLocalSuggestions,
    InputCSRWithBalance,
    InputTagWithOrderType,
    InputDatePicker,
    InputDateRangePicker,
    InputShow
  },
  props: {
    config: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      element: make(this.config)
    }
  }
}
</script>
